import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fireErrorAnalytics } from '@atlassian/ui-modifications-analytics';
import { getSupportedFieldConfiguration } from '../../../view-configuration';
export var transformFieldToIframe = function transformFieldToIframe(fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata) {
  var fieldConfiguration = getSupportedFieldConfiguration(viewType, fieldType);
  var fieldInternalToPublicTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.internalToPublicTransformers;
  var publicShapeField = _objectSpread({}, fieldChanges);
  if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.value) {
    try {
      publicShapeField.value = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.value(fieldChanges.value, fieldMetadata.fieldRenderer);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
      fireErrorAnalytics({
        error: err,
        id: 'internalToPublicValueTransformer',
        viewType: viewType,
        attributes: {
          fieldType: fieldType
        }
      });
    }
  }
  if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.optionsVisibility) {
    try {
      var lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - lookupData is not types on CI somehow
      var lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
      publicShapeField.optionsVisibility = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
      fireErrorAnalytics({
        error: err,
        id: 'internalToPublicOptionsVisibilityTransformer',
        viewType: viewType,
        attributes: {
          fieldType: fieldType
        }
      });
    }
  }
  return publicShapeField;
};